<template>
  <span class="shopCheck">
    <el-checkbox
      size="medium"
      v-model="checked"
      v-on:change="whenValueChangeFun"
      >{{ myLabel }}</el-checkbox
    >
    <el-input
      v-if="checked"
      size="mini"
      style="width: 4rem"
      min="1"
      max="10"
      :disabled="!checked"
      v-model="num"
      type="Number"
      v-on:input="whenNumValueChangeFun"
    ></el-input>
  </span>
</template>

<script>
export default {
  emits: ['addToTempsArrayEvent', 'removeFromTempsArrayEvent', 'numValueChangeEvent'],
  props: {
    tempId: Number,
    showLable: String
  },
  mounted () {
    this.myTempId = this.tempId
    this.myLabel = this.showLable
  },
  data () {
    return {
      myTempId: null,
      myLabel: null,
      checked: false,
      num: 1
    }
  },
  methods: {
    whenValueChangeFun (newValue) {
      if (newValue) {
        this.$emit('addToTempsArrayEvent', this.myTempId)
      } else {
        this.$emit('removeFromTempsArrayEvent', this.myTempId)
      }
    },
    whenNumValueChangeFun (newValue) {
      this.$emit('numValueChangeEvent', this.myTempId, newValue)
    }
  }
}
</script>

<style scoped>
.shopCheck :deep(.el-checkbox__label) {
  line-height: 30px;
  color: #fff;
  font-size: 18px;
}
.shopCheck :deep(.el-input__inner) {
  padding: 0;
  text-align: center;
  background-color: transparent;
  color: #fff;
}
.shopCheck :deep(.el-checkbox__input.is-checked + .el-checkbox__label) {
  color: #fff;
}
.shopCheck :deep(.el-checkbox__input) {
  vertical-align: inherit;
}

.shopCheck :deep(.el-input--mini .el-input__inner) {
  line-height: 35px;
}

.shopCheck :deep(.el-checkbox__inner) {
  background-color: transparent;
}
</style>
